import { Cirus } from "@/classes/Http";

enum BannerPostion {
    CUSTOM = "custom",
    MAIN = "main",
    SOCIAL_SHOP = "social_shop"
}

export class CreateInstanceBannerCategoryBody {
    type: BannerPostion;
    title: string;
}

export function createBannerCategory(instance_id: number, params: CreateInstanceBannerCategoryBody) {
    const path = `/instance/${instance_id}/banner-category`;
    return Cirus.put(path, params);
}